import {AbstractControl, ValidationErrors, Validator} from '@angular/forms';
import {ValidationRule} from '../../rules/rules';

export abstract class BaseValidatorDirective<T extends ValidationRule> implements Validator {
    protected internalRule: T;
    protected validatorChangeFn: () => void;

    public registerOnValidatorChange($fn: () => void): void {
        this.validatorChangeFn = $fn;
    }

    public validate($c: AbstractControl): ValidationErrors | null {
        if (this.internalRule) {
            return this.internalRule.validator($c);
        }
        return null;
    }

    protected set rule($value: T) {
        this.internalRule = $value;
        if (this.validatorChangeFn) {
            this.validatorChangeFn();
            // This should be controlled from outside by design. When rule is changed form validation state must be reset.
            // this.lastValidatedControl.updateValueAndValidity({onlySelf: true});
        }
    }

    protected get rule(): T {
        return this.internalRule;
    }
}
